import React from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  FirstAds,
  SecondAds,
  MobileUnderCalAds,
} from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
import ValueOfPercentage from "./ValueOfPercentage";
import ValueOfWhatCalculator from "./ValueOfWhatCalculator";
import PercentageDifferenceCalculator from "./PercentageDifferenceCalculator";
import PercentageChangeCalculator from "./PercentageChangeCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حساب النسبة المئوية";
const DESCRIPTION =
  "أداة مفيدة للتحليل المالي والإحصائي. احسب النسبة المئوية بسهولة للأعداد . تدعم النسبة المئوية العادية والمتغيرة بالزيادة والنقصان، وفرق النسبة بين الأرقام وحساب النسبة المئوية الصحيحة";
const KEYWORDS =
  "حاسبة النسبة المئوية, نسبة مئوية, فرق النسبة المئوية, نسبة مئوية من مبلغ, نسبة مئوية من عدد, استخراج النسبة, الفرق المئوي, تغير النسبة المئوية, حاسبة النسبة";
const OG_URL = "https://do-calculate.com/calculator/ar/percentage/";
function Percentage() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة النسبة المئوية هي أداة عملية ومتكاملة تمكّن المستخدمين
                  من استخراج ومعرفة وحساب النسب المئوية من مبلغ أو عدد والنسبة
                  المئوية للمجموع وفقًا لمختلف الصيغ الحسابية. تتيح للمستخدمين
                  حساب النسب المئوية العادية والنسب المئوية المتغيرة بالزيادة
                  والنقصان، وكذلك فرق النسبة المئوية بين رقمين أو عددين. تُعتبر
                  هذه الحاسبة أداة قوية ومفيدة للتحليل المالي والإحصائي، مع
                  توفير سهولة الاستخدام وواجهة بسيطة تتيح للمستخدمين إدخال القيم
                  بسهولة والحصول على النتائج بسرعة. استخدام الحاسبة في الحسابات
                  المالية، التحليل الإحصائي، وتقدير الزيادات والنقصان يجعلها
                  أداة ضرورية للأفراد والمهنيين في مختلف المجالات.
                </p>
                <p>
                  تقوم أداة حساب النسبة المئوية بإجراء حساب دقيق للنسبة المئوية
                  بناءً على القيم التي تدخلونها. على سبيل المثال، إذا كان لديك
                  الرصيد 500 دولار وترغب في معرفة 15% من هذا المبلغ، يمكنك
                  ببساطة إدخال النسبة 15% في مربع إدخال النسبة المئوية، وإدخال
                  الرصيد 500 في مربع إدخال العدد. بعد ذلك، انقر على زر "احسب"
                  للحصول على النتيجة النهائية. بهذه الطريقة، يمكنك سريعاً وبدون
                  تعقيدات حساب نسبة المئوية لأي مبلغ. سواء كنت ترغب في معرفة
                  الخصم على سلعة بنسبة معينة أو توزيع النسب المئوية للمصروفات
                  الشهرية، يوفر هذا الأداة حلاً فعالًا وسهلاً لتلبية احتياجاتك
                  في حساب النسب المئوية.
                </p>
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-9 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>احسب النسبة المئوية </h2>
                </div>
                <hr />
                <PercentageCalculator />
                <hr />
                <ValueOfPercentage />
                <hr />
                <ValueOfWhatCalculator />
                <hr />
                <PercentageDifferenceCalculator />
                <hr />
                <PercentageChangeCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب النسبة المئوية </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية حساب النسبة المئوية
                    </h2>{" "}
                  </u>
                  <p>
                    النسبة المئوية هي قياس يُعبِّر عن عدد أو كمية بالنسبة إلى
                    إجماليها مضروبًا في 100. وبالتالي، فإنها تعبر عن جزء من الكل
                    بالنسبة للمئة.
                  </p>
                  <p>
                    عند حساب النسبة المئوية لعدد أو كمية ما، نقسم العدد المراد
                    قياس نسبته على القيمة الكلية، ثم نضرب النتيجة في 100 للتعبير
                    عنها بالنسبة المئوية.
                  </p>
                  <p>
                    الصيغة الرياضية لحساب النسبة المئوية هي كالتالي: النسبة
                    المئوية = (العدد المراد قياس نسبته ÷ القيمة الكلية) × 100
                  </p>
                  <div className="p-3 mb-2 bg-info  ">
                    على سبيل المثال، إذا كان لدينا 10 فقاعات، ومنها 2 فقاعة
                    حمراء، فإن النسبة المئوية للفقاعات الحمراء تكون كالتالي: (2
                    ÷ 10) × 100 = 0.2 × 100 = 20%
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      حاسبة تغيير النسبة المئوية
                    </h2>{" "}
                  </u>
                  <p>
                    الحاسبة تعمل على حساب الزيادة أو النقصان باستخدام النسب
                    المئوية. عند استخدامها، يقوم المستخدم بإدخال قيمتين:
                  </p>
                  <ul>
                    <li>
                      القيمة الأولى: هي القيمة التي ترغب في حساب النسبة المئوية
                      لها.
                    </li>
                    <li>
                      القيمة الثانية: هي النسبة المئوية التي ترغب في استخدامها
                      في الحساب، سواء كانت زيادة أو نقصان.
                    </li>
                  </ul>
                  <p>
                    بعد إدخال هاتين القيمتين، يقوم المستخدم بالنقر على زر
                    "إحسب". ثم تقوم الحاسبة بحساب القيمة المستهدفة وعرضها
                    بالنسبة المئوية.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    لنفترض أن لدينا قيمة 100 ونرغب في حساب ما ستكون عند زيادتها
                    بنسبة 10٪. نقوم بإدخال القيمتين في المدخلات ونختار "زيادة"
                    من مربع الاختيار وندخل النسبة "10". بعد النقر على زر "إحسب"،
                    ستقوم الحاسبة بحساب القيمة النهائية وعرضها. في هذا المثال،
                    ستكون القيمة النهائية 110، أي أن القيمة 100 زادت بنسبة 10٪.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>حاسبة الفرق المئوي</h2>{" "}
                  </u>
                  <p>
                    {" "}
                    هذه الحاسبة تسمح للمستخدم بحساب الفرق المئوي بين قيمتين. عند
                    استخدامها، يقوم المستخدم بإدخال القيمتين:
                  </p>
                  <ul>
                    <li>
                      القيمة 1: هي القيمة الأولى التي ترغب في حساب الفرق المئوي
                      مع قيمة أخرى.
                    </li>
                    <li>
                      القيمة 2: هي القيمة الثانية التي ترغب في حساب الفرق المئوي
                      مع القيمة الأولى.
                    </li>
                  </ul>
                  <p>
                    بعد إدخال القيمتين، يقوم المستخدم بالنقر على زر "إحسب". ثم
                    تقوم الحاسبة بحساب الفرق المئوي بين القيمتين وعرض النتيجة
                    بالنسبة المئوية.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    لنفترض أن لدينا قيمة 100 وقيمة 80، ونرغب في حساب الفرق
                    المئوي بينهما. نقوم بإدخال القيمتين في المدخلات وننقر على زر
                    "إحسب". ستقوم الحاسبة بحساب الفرق المئوي بين القيمتين،
                    وسنحصل على النتيجة بالنسبة المئوية.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      حساب النسبة المئوية من مبلغ
                    </h2>{" "}
                  </u>
                  <p>
                    استخدم حاسبة النسب المئوية من المبلغ لتسهيل عملية حساب النسب
                    المئوية لأي مبلغ تحدده. ببساطة، قم بإدخال المبلغ والنسبة
                    المطلوبة للحصول على النتيجة بسرعة ودقة. يُمكنك الاعتماد على
                    هذه الحاسبة لتسهيل تقديراتك المالية وفهم كيفية توزيع النسب
                    المئوية للمبالغ بسهولة وفعالية.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    استخدم حاسبة النسب المئوية من المبلغ لمعرفة كم تكون نسبة 20٪
                    من 5000 ريال. قم بإدخال المبلغ (5000) والنسبة المئوية
                    المطلوبة (20)، ثم احصل على النتيجة بسهولة. بذلك، ستكون
                    النتيجة هي 1000 ريال، وهي القيمة التي تمثل 20٪ من المبلغ
                    الأصلي.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Percentage;
